@if (available()) {
  <!-- Zelfde opbouw als de profiel-/kruis-zoektochten in Basis: een tegel met de
       zoekknop rechts en de resultaten in de footer. -->
  <hd-property-tile #tile class="lk-search" icon="lock-keyhole" [label]="t('search.title')" data-test-id="locks-keys-chart-search">
    <button tileAction type="button" hdChartMatchToggle class="lk-search__toggle"
            [open]="open()"
            [tooltip]="t('search.toggleTooltip')"
            data-test-id="locks-keys-chart-search-toggle"
            (click)="toggle()"></button>
    <button type="button" class="lk-search__summary" [title]="t('search.toggleTooltip')" (click)="toggle()">
      {{ summary() }}
    </button>

    @if (open()) {
      <div tileFooter class="lk-search__footer">
        <e-segmented-toggle
          class="lk-search__kinds"
          size="xs"
          block
          [options]="kindOptions()"
          [value]="kind()"
          [groupLabel]="t('search.kindLabel')"
          testId="locks-keys-chart-search-kind"
          (valueChange)="setKind($event)"
        ></e-segmented-toggle>
        <p class="lk-search__hint">{{ hint() }}</p>

        @if (!hasCandidates()) {
          <p class="lk-search__none" data-test-id="locks-keys-chart-search-none">{{ t('search.noSource.' + kind()) }}</p>
        } @else {
          <hd-chart-match-list [state]="listState()" [labels]="labels()" [highlight]="isMutual"
                               [resetKey]="chartKey()" [revealOnOpen]="false" (open)="openMatch($event)">
            <!-- Weergavekeuzes (bewaard in de gebruikersinstellingen) rechts in de
                 kopregel, naast de scope: werken op de treffers, zonder nieuwe zoektocht. -->
            <span matchListHead class="lk-search__view">
              <e-segmented-toggle
                size="xs"
                [options]="sortOptions()"
                [value]="state.searchSort()"
                [groupLabel]="t('search.sortLabel')"
                testId="locks-keys-chart-search-sort"
                (valueChange)="setSort($event)"
              ></e-segmented-toggle>
              <e-segmented-toggle
                size="xs"
                [options]="filterOptions()"
                [value]="state.searchFilter()"
                [groupLabel]="t('search.filterLabel')"
                testId="locks-keys-chart-search-filter"
                (valueChange)="setFilter($event)"
              ></e-segmented-toggle>
            </span>
            <ng-template let-match>
              @if (match.mutual) {
                <i class="fas fa-arrow-right-arrow-left lk-search__mutual" [title]="t('search.mutualTooltip')" aria-hidden="true"></i>
              }
              @for (relation of match.relations; track relationTrack(relation)) {
                <!-- Wat de gevonden chart invult staat voorop en valt op (gekleurd kadertje
                     met zijn key of lock en de activerende planeet); jouw poort volgt gedimd,
                     de pijl wijst in openingsrichting (key → lock). Keys blauw, locks goud. -->
                <span class="lk-rel" [attr.data-direction]="relation.direction" [title]="relationTooltip(match, relation)">
                  <span class="lk-rel__their">
                    <i class="fas lk-rel__role" aria-hidden="true"
                       [class.fa-key]="relation.direction === 'theirKey'"
                       [class.fa-lock]="relation.direction === 'theirLock'"></i>
                    @for (activation of relation.activations; track $index) {
                      <hd-gate-activation-chip [gate]="activation.gate" [line]="activation.line"
                                               [side]="activation.side" [planetId]="activation.planetId"></hd-gate-activation-chip>
                    }
                  </span>
                  <span class="lk-rel__mine">
                    <i class="fas lk-rel__arrow" aria-hidden="true"
                       [class.fa-arrow-right]="relation.direction === 'theirKey'"
                       [class.fa-arrow-left]="relation.direction === 'theirLock'"></i>
                    <i class="fas lk-rel__mine-role" aria-hidden="true"
                       [class.fa-lock]="relation.direction === 'theirKey'"
                       [class.fa-key]="relation.direction === 'theirLock'"></i>{{ relation.myGate }}
                  </span>
                </span>
              }
            </ng-template>
          </hd-chart-match-list>
        }

        <div class="lk-search__actions">
          <button type="button" class="lk-search__close"
                  data-test-id="locks-keys-chart-search-close"
                  (click)="close()">
            <i class="fas fa-xmark" aria-hidden="true"></i>
            {{ t('search.close') }}
          </button>
        </div>
      </div>
    }
  </hd-property-tile>
}
